import { useRouter } from 'next/router';
import { StarBorderRounded, StarRounded } from '@mui/icons-material';
import {
  ToggleButton, Tooltip, ToggleButtonGroup,
} from '@mui/material';
import { updateRouterQuery } from 'lib/utils/filterUtils';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { useSignUpModal } from 'components/SignUpModal';
import { trackClickSignupEvent } from 'lib/hooks/useEventTracking';

const DEFAULT_QUERY_KEY = 'onlyFromSavedCreators';

interface Props {
  // queryKey defines the query param that should be set.
  queryKey?: string;
  selected?: boolean;
  disabled?: boolean;
}

export const OnlySavedFilter = ({
  selected = false,
  queryKey = DEFAULT_QUERY_KEY,
  disabled = false,
}: Props) => {
  const router = useRouter();
  const currentUser = useCurrentUser();
  const { showSignUpModal } = useSignUpModal();
  const API = useApi();

  const onChange = (n: boolean) => {
    if (!currentUser) {
      trackClickSignupEvent(API, 'only-saved-filter');
      showSignUpModal('Sign in to filter your favorite posts');
      return;
    }
    if (!n) {
      updateRouterQuery(router, { [queryKey]: [] });
      return;
    }
    updateRouterQuery(router, { [queryKey]: 'true' });
  };

  return (
    <Tooltip title="Filter by saved posts" placement="top" arrow>
      <ToggleButtonGroup
        onChange={() => onChange(!selected)}
        disabled={disabled}
      >
        <ToggleButton
          value
          selected={selected}
          size="small"
          disabled={disabled}
          style={{
            color: '#EDC679',
          }}
        >
          {selected ? <StarRounded color="inherit" /> : <StarBorderRounded color="inherit" />}
        </ToggleButton>
      </ToggleButtonGroup>
    </Tooltip>
  );
};
